/* eslint-disable react/prop-types */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable react/function-component-definition */
/* eslint-disable spaced-comment */
/* eslint-disable no-extra-boolean-cast */
import React from 'react';
import { Page, Image, View, Document, StyleSheet, Text, Font } from '@react-pdf/renderer';
import BG_FRONT from './card front.png';
import BG_BACK from './card back.png';
import QR_IMAGE from './qrcode.jpg';
import { themeColor } from '../../../config/theme/themeVariables';

// Conversion constants
const DPI = 300; // Standard Photoshop DPI
const PDF_DPI = 72; // Standard PDF DPI
const CONVERT = PDF_DPI / DPI;

// Constants
const cardsPerPage = 5; // Maximum cards per page
const cardWidth = 1059 * CONVERT;
const cardHeight = 672 * CONVERT;
const frontX = 124 * CONVERT;
const backX = 1302 * CONVERT;
const topStart = 32 * CONVERT;
const verticalSpacing = 691 * CONVERT; // Spacing between cards (calculated from y positions)

Font.register({
  family: 'MyFont_BOLD',
  fontWeight: 'bold',
  src: require('../../../static/fonts/Halagar.otf'),
});

Font.register({
  family: 'TABLE_FONT_CELL',
  fontWeight: 'bold',
  src: require('../../../static/fonts/RobotoCondensed-SemiBold.ttf'),
});

// Styles for positioning and dimensions
const styles = StyleSheet.create({
  page: {
    position: 'relative',
  },
  card: {
    position: 'absolute',
    width: cardWidth,
    height: cardHeight,
  },
  cardDetails: {
    position: 'absolute',
    padding: 5,
    fontSize: 10,
    color: '#000',
  },
  picture: {
    width: 186 * CONVERT,
    height: 225 * CONVERT,
    position: 'absolute',
    top: 297 * CONVERT,
    left: 29 * CONVERT,
  },
  signature: {
    position: 'absolute',
    bottom: 80 * CONVERT,
    right: 15 * CONVERT,
    width: 80,
    height: 40,
  },
  qrImage: {
    position: 'absolute',
    top: 260 * CONVERT,
    right: 58 * CONVERT,
    width: 33,
    height: 37,
  },
  textRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 2,
  },
  label: {
    fontSize: 8,
    color: 'gray',
    fontFamily: 'TABLE_FONT_CELL'
  },
  value: {
    fontSize: 10,
    fontWeight: 'heavy',
    fontFamily: 'TABLE_FONT_CELL'
  },
});

const MyDocument = ({ cards = [], issuanceAuthority }) => {
  const pageSize = 'A4';

  // Calculate the page count dynamically based on cards
  const pages = [];
  for (let i = 0; i < cards.length; i += cardsPerPage) {
    pages.push(cards.slice(i, i + cardsPerPage));
  }

  return (
    <Document>
      {pages.map((pageCards, pageIndex) => (
        <Page key={pageIndex} size={pageSize} style={styles.page} fixed>
          {pageCards.map((card, cardIndex) => {
            const top = topStart + cardIndex * verticalSpacing;

            return (
              <React.Fragment key={cardIndex}>
                {/* Front Side */}
                <View
                  style={{
                    top,
                    left: frontX,
                    width: cardWidth,
                    height: cardHeight,
                    position: 'absolute',
                  }}
                >
                  <Image src={BG_FRONT} style={styles.card} />
                  <Image src={card.picture} style={styles.picture} />
                  <View style={[styles.cardDetails, { top: 268 * CONVERT, left: 52, right: 20 }]}>
                    <Text style={styles.textRow}>
                      <Text style={styles.label}>Serial Number:</Text> &nbsp;
                      <Text style={[styles.value, { color: themeColor['error-color'] }]}>
                        {card.serial_no}
                      </Text>
                    </Text>
                    <Text style={styles.textRow}>
                      <Text style={styles.label}>Name:</Text> &nbsp;
                      <Text style={styles.value}>{card.emp_name}</Text>
                    </Text>
                    <Text style={styles.textRow}>
                      <Text style={styles.label}>Father Name:</Text> &nbsp;
                      <Text style={styles.value}>{card.emp_father_name}</Text>
                    </Text>
                    <Text style={styles.textRow}>
                      <Text style={styles.label}>CNIC:</Text> &nbsp;
                      <Text style={styles.value}>{card.emp_cnic}</Text>
                    </Text>
                  </View>
                  <Image src={issuanceAuthority} style={styles.signature} />
                </View>

                {/* Back Side */}
                <View
                  style={{
                    top,
                    left: backX,
                    width: cardWidth,
                    height: cardHeight,
                    position: 'absolute',
                  }}
                >
                  <Image src={BG_BACK} style={styles.card} />
                  <View style={[styles.cardDetails, { top: 230 * CONVERT, left: 10, right: 50 }]}>
                    <Text style={styles.textRow}>
                      <Text style={styles.label}>Company:</Text> &nbsp;
                      <Text style={[styles.value, { color: themeColor['error-color'] }]}>
                        {card.comp_name}
                      </Text>
                    </Text>
                    <Text style={styles.textRow}>
                      <Text style={styles.label}>Designation:</Text> &nbsp;
                      <Text style={styles.value}>{card.emp_desig_title}</Text>
                    </Text>
                    <Text style={styles.textRow}>
                      <Text style={styles.label}>Issue Date:</Text> &nbsp;
                      <Text style={styles.value}>{card.issue_date}</Text>
                    </Text>
                    <Text style={styles.textRow}>
                      <Text style={styles.label}>Valid Upto:</Text> &nbsp;
                      <Text style={styles.value}>{card.valid_upto}</Text>
                    </Text>
                  </View>
                  <Image src={QR_IMAGE} style={styles.qrImage} />
                </View>
              </React.Fragment>
            );
          })}
        </Page>
      ))}
    </Document>
  );
};

export default MyDocument;
